<template>
  <div class="no-availability-dates">
    <button
      v-if="!isAdultsOnlyAndChild()"
      @click="$emit('checkAvailability', hotel)"
      class="btn btn-link no-availability-dates__icon-button"
    >
      <i
        class="icon xl color-primary no-availability-dates__icon"
        :class="isMinNightsStay ? 'icon-calendar-arrow' : 'icon-calendar-no-availability'"
      />
    </button>
    <i v-else class="icon rhg-font-icon--notifications xl color-primary" />
    <div v-if="isAdultsOnlyAndChild()" class="no-availability-dates__message">
      <span class="no-availability-dates__title">{{ translate('rdAdultsOnlyHotelTitle') }}</span>
      <span class="no-availability-dates__description">{{
        translate('rdAdultsOnlyDescription')
      }}</span>
    </div>
    <div v-else-if="isMinNightsStay" class="no-availability-dates__message">
      <span class="no-availability-dates__title">{{
        translate('srThereAreNoAvailableRoomsMinNight', '', hotel.minNightsPerStay)
      }}</span>
      <span class="no-availability-dates__description">{{
        translate('srThereAreNoAvailableRoomsMinNightSubtitle', '', hotel.minNightsPerStay)
      }}</span>
    </div>
    <div v-else class="no-availability-dates__message">
      <span class="no-availability-dates__title">{{
        translate('srThereAreNoAvailableRooms')
      }}</span>
      <span class="no-availability-dates__description">{{
        translate('srRecommendChagingDates')
      }}</span>
    </div>
    <Button
      v-if="!isAdultsOnlyAndChild()"
      id="noAvailabilityCta"
      :label="translate('rdChangeDates')"
      @click="$emit('checkAvailability', hotel)"
    ></Button>
  </div>
</template>

<script>
import Hotel from '../../domain/Hotel'
import { Button } from 'rhg-vue-components'
import { getQueryParams } from '@/infrastructure/Utils'

export default {
  name: 'NoAvailabilityDates',
  components: { Button },
  props: {
    hotel: {
      type: Hotel
    },
    isMinNightsStay: {
      type: Boolean,
      default: false
    }
  },
  methods: {
    isAdultHotel() {
      return this.hotel?.notificationMessages[0]?.text.includes('16')
    },
    isAdultsOnlyAndChild() {
      return (
        getQueryParams(window.location.search)?.children?.some(value => value >= 1) &&
        this.isAdultHotel()
      )
    }
  }
}
</script>

<style lang="scss" scoped>
.no-availability-dates {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: white;
  padding: 5rem 3rem;

  &__icon {
    cursor: pointer;
  }

  &__message {
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 3rem 0;
  }

  &__title {
    font-weight: bold;
    font-size: 18px;
    line-height: 25px;
    text-align: center;
  }

  &__description {
    font-style: normal;
    font-weight: normal;
    font-size: 12px;
    line-height: 20px;
    text-align: center;
  }

  &__icon-button {
    outline: none;
    box-shadow: none;
  }
}
</style>
